import React, { Fragment, useState, useEffect, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import FormLabel from "@material-ui/core/FormLabel";
import Divider from "@material-ui/core/Divider";
import Alert from "@material-ui/lab/Alert";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Checkbox from "@material-ui/core/Checkbox";
import {
  Reorder,
  Repeat,
  Pageview,
  CheckBoxOutlineBlank,
  CheckBox,
  Opacity,
} from "@material-ui/icons";
import axios from "axios";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Tooltip from "@material-ui/core/Tooltip";
import Skeleton from "@material-ui/lab/Skeleton";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "@material-ui/core/Button";

import ResourcesData from "views/dialog/ResourcesData";
import WasteResourcesData from "views/dialog/WasteResourcesData";

import {
  cardStyle,
  HtmlTooltipCss,
} from "assets/jss/material-dashboard-react/components/cardStyle";

const useStyles = makeStyles(cardStyle);

const HtmlTooltip = withStyles(HtmlTooltipCss)(Tooltip);

export default function Have() {
  const classes = useStyles();
  const [loader, setLoader] = useState(true);
  const [openAlertsuccess, setOpenAlertsuccess] = useState(false);
  const [openBackdrop, setoOpenBackdrop] = useState(false);
  const [mensaje_success, setMensaje_success] = useState("");
  const [errorServer, setErrorServer] = useState(false);
  const [catSelect, setCatSelect] = useState(false);
  const [catSelectValue, setCatSelectValue] = useState("");
  const [dataCat, setdataCat] = useState("");
  const [delectCat, setdelectCat] = useState([]);

  const [catSelectWaste, setCatSelectWaste] = useState(false);
  const [catSelectValueWaste, setCatSelectValueWaste] = useState("");
  const [dataCatWaste, setdataCatWaste] = useState("");

  let keyAuthorization = localStorage.getItem("Session");

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  const [values, setValues] = useState({
    deliveryLogistics: [],
    deliveryLogisticsData: [],
    deliveryLogisticsDataViews: [],
    logisticsOutbound: [],
    logisticsOutboundData: [],
    logisticsOutboundDataViews: [],
    operations: [],
    operationsData: [],
    operationsDataViews: [],
    marketing: [],
    marketingData: [],
    marketingDataViews: [],
    services: [],
    servicesData: [],
    servicesDataViews: [],
    /* APOYO Y SOPORTE YO TENGO*/
    infrastructure: [],
    infrastructureData: [],
    infrastructureDataViews: [],
    humanResources: [],
    humanResourcesData: [],
    humanResourcesDataViews: [],
    developmentTechnology: [],
    developmentTechnologyData: [],
    developmentTechnologyDataViews: [],
    buy: [],
    buyData: [],
    buyDataViews: [],
    deliveryLogisticsSave: [],
    operationsSave: [],
    logisticsOutboundSave: [],
    marketingSave: [],
    servicesSave: [],
    infrastructureSave: [],
    humanResourcesSave: [],
    developmentTechnologySave: [],
    buySave: [],
    /*  RESIDUOS ORGANICOS*/
    organicWaste: [],
    organicWasteData: [],
    organicWasteDataViews: [],
    organicWasteSave: [],
    /*  ALERT RECUROS TENGO*/
    errorDeliveryLogistics: false,
    errorLogisticsOutbound: false,
    errorOperations: false,
    errorMarketing: false,
    errorServices: false,
    errorInfrastructure: false,
    errorHumanResources: false,
    errorDevelopmentTechnology: false,
    errorBuy: false,
  });

  const dataValuesHave = (data) => {
    let resultData = [];

    data.map((items, i) => {
      resultData.push({
        id: items.id,
        detailName: items.have_name,
        code: items.have_id,
        cat_id: items.catalog_id,
        description: items.description,
        estimatedAmount: items.estimated_mount_id,
        transactionType: JSON.parse(items.transaction_type),
        estimatedAmountName: items.estimated_mount_name,
      });
    });

    return resultData;
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    const dataCat = {
      catalogs: [
        {
          detailName: "catLogisticaEntrega",
          codeExclusion: "0",
        },
        {
          detailName: "catOperaciones",
          codeExclusion: "0",
        },
        {
          detailName: "catLogisticaSalida",
          codeExclusion: "0",
        },
        {
          detailName: "catMarketing",
          codeExclusion: "0",
        },
        {
          detailName: "catServicios",
          codeExclusion: "0",
        },
        {
          detailName: "catInfraestructura",
          codeExclusion: "0",
        },
        {
          detailName: "catRecursosHumano",
          codeExclusion: "0",
        },
        {
          detailName: "catTecnologia",
          codeExclusion: "0",
        },
        {
          detailName: "catCompra",
          codeExclusion: "0",
        },
        {
          detailName: "catOrganicWaste",
          codeExclusion: "0",
        },
      ],
    };

    axios
      .post(`${urlServices}catalogsDetails/getMultiplesCatalogs`, dataCat, {
        headers: {
          application: keyAplication,
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            axios
              .get(
                `${urlServices}stakeholders/user/${localStorage.getItem("id")}`,
                {
                  headers: {
                    application: keyAplication,
                  },
                }
              )
              .then(
                (response2) => {
                  if (response2.status === 200) {
                    let catLogisticaEntrega = [],
                      resultData = [],
                      resultDataSave = [],
                      catOperaciones = [],
                      resultData1 = [],
                      resultDataSave1 = [],
                      catLogisticaSalida = [],
                      resultData2 = [],
                      resultDataSave2 = [],
                      catMarketing = [],
                      resultData3 = [],
                      resultDataSave3 = [],
                      catServicios = [],
                      resultData4 = [],
                      resultDataSave4 = [],
                      catInfraestructura = [],
                      resultData5 = [],
                      resultDataSave5 = [],
                      catRecursosHumano = [],
                      resultData6 = [],
                      resultDataSave6 = [],
                      catTecnologia = [],
                      resultData7 = [],
                      resultDataSave7 = [],
                      catCompra = [],
                      resultData8 = [],
                      resultDataSave8 = [],
                      catOrganicWaste = [],
                      resultData9 = [],
                      resultDataSave9 = [];

                    if (response2.data.stakeholderHave.length > 0) {
                      catLogisticaEntrega =
                        response2.data.stakeholderHave.filter(
                          (filtered) => filtered.catalog_id === 4
                        );
                      resultData = dataValuesHave(catLogisticaEntrega);
                      resultDataSave = dataValuesHave(catLogisticaEntrega);

                      catOperaciones = response2.data.stakeholderHave.filter(
                        (filtered) => filtered.catalog_id === 5
                      );
                      resultData1 = dataValuesHave(catOperaciones);
                      resultDataSave1 = dataValuesHave(catOperaciones);

                      catLogisticaSalida =
                        response2.data.stakeholderHave.filter(
                          (filtered) => filtered.catalog_id === 6
                        );
                      resultData2 = dataValuesHave(catLogisticaSalida);
                      resultDataSave2 = dataValuesHave(catLogisticaSalida);

                      catMarketing = response2.data.stakeholderHave.filter(
                        (filtered) => filtered.catalog_id === 7
                      );
                      resultData3 = dataValuesHave(catMarketing);
                      resultDataSave3 = dataValuesHave(catMarketing);

                      catServicios = response2.data.stakeholderHave.filter(
                        (filtered) => filtered.catalog_id === 8
                      );
                      resultData4 = dataValuesHave(catServicios);
                      resultDataSave4 = dataValuesHave(catServicios);

                      catInfraestructura =
                        response2.data.stakeholderHave.filter(
                          (filtered) => filtered.catalog_id === 9
                        );
                      resultData5 = dataValuesHave(catInfraestructura);
                      resultDataSave5 = dataValuesHave(catInfraestructura);

                      catRecursosHumano = response2.data.stakeholderHave.filter(
                        (filtered) => filtered.catalog_id === 10
                      );
                      resultData6 = dataValuesHave(catRecursosHumano);
                      resultDataSave6 = dataValuesHave(catRecursosHumano);

                      catTecnologia = response2.data.stakeholderHave.filter(
                        (filtered) => filtered.catalog_id === 11
                      );
                      resultData7 = dataValuesHave(catTecnologia);
                      resultDataSave7 = dataValuesHave(catTecnologia);

                      catCompra = response2.data.stakeholderHave.filter(
                        (filtered) => filtered.catalog_id === 12
                      );
                      resultData8 = dataValuesHave(catCompra);
                      resultDataSave8 = dataValuesHave(catCompra);

                      catOrganicWaste = response2.data.stakeholderHave.filter(
                        (filtered) => filtered.catalog_id === 20
                      );
                      resultData9 = dataValuesHave(catOrganicWaste);
                      resultDataSave9 = dataValuesHave(catOrganicWaste);
                    }

                    setValues({
                      ...values,
                      stakeholder_id: response2.data.id,
                      deliveryLogisticsSave: resultDataSave,
                      operationsSave: resultDataSave1,
                      logisticsOutboundSave: resultDataSave2,
                      marketingSave: resultDataSave3,
                      servicesSave: resultDataSave4,
                      infrastructureSave: resultDataSave5,
                      humanResourcesSave: resultDataSave6,
                      developmentTechnologySave: resultDataSave7,
                      buySave: resultDataSave8,
                      organicWasteSave: resultDataSave9,
                      deliveryLogisticsData: resultData,
                      deliveryLogisticsDataViews: resultData,
                      operationsData: resultData1,
                      operationsDataViews: resultData1,
                      logisticsOutboundData: resultData2,
                      logisticsOutboundDataViews: resultData2,
                      marketingData: resultData3,
                      marketingDataViews: resultData3,
                      servicesData: resultData4,
                      servicesDataViews: resultData4,
                      infrastructureData: resultData5,
                      infrastructureDataViews: resultData5,
                      humanResourcesData: resultData6,
                      humanResourcesDataViews: resultData6,
                      developmentTechnologyData: resultData7,
                      developmentTechnologyDataViews: resultData7,
                      buyData: resultData8,
                      buyDataViews: resultData8,
                      organicWasteData: resultData9,
                      organicWasteDataViews: resultData9,
                      deliveryLogistics:
                        response.data.catalogs.catLogisticaEntrega,
                      logisticsOutbound:
                        response.data.catalogs.catLogisticaSalida,
                      operations: response.data.catalogs.catOperaciones,
                      marketing: response.data.catalogs.catMarketing,
                      services: response.data.catalogs.catServicios,
                      infrastructure: response.data.catalogs.catInfraestructura,
                      humanResources: response.data.catalogs.catRecursosHumano,
                      developmentTechnology:
                        response.data.catalogs.catTecnologia,
                      buy: response.data.catalogs.catCompra,
                      organicWaste: response.data.catalogs.catOrganicWaste,
                    });
                    setLoader(false);
                  }
                },
                (error) => {
                  console.log(error);
                }
              );

            setLoader(false);
          }
        },
        (error) => {
          console.log(error);
          setErrorServer(true);
        }
      );
  }, [urlServices, keyAplication]);

  const callbackResourcesData = (data) => {
    if (data.save !== 0) {
      let arr = values[catSelectValue.cat + "Views"];
      arr.push({
        detailName: data.detailName,
        code: data.code,
        cat_id: data.cat_id,
        description: data.description,
        estimatedAmount: data.estimatedAmount,
        transactionType: data.transactionType,
        estimatedAmountName: data.estimatedAmountName,
      });

      setValues({ ...values, [catSelectValue.cat + "Views"]: arr });
    } else {
      catSelectValue.value.map((items, i) => {
        if (items.catalog_id === data.cat_id) {
          if (items.code === data.code) {
            catSelectValue.value.splice(i, 1);
          }
        }
      });

      setValues({ ...values, [catSelectValue.cat]: catSelectValue.value });
    }

    setCatSelect(false);
  };

  const callbackWasteResourcesData = (data) => {
    if (data.save !== 0) {
      let arr = values[catSelectValueWaste.cat + "Views"];

      arr.push({
        detailName: data.detailName,
        code: data.code,
        cat_id: data.cat_id,
        wasteState: data.wasteState,
        wasteStateName: data.wasteStateName,
        estimatedAmount: data.estimatedAmount,
        estimatedAmountName: data.estimatedAmountName,
        weightKg: data.weightKg,
        weightKgName: data.weightKgName,
        transports: data.transports,
        transportsName: data.transportsName,
        transactionType: data.transactionType,
        wasteUsage: data.wasteUsage,
        wasteUsageName: data.wasteUsageName,
      });

      setValues({ ...values, [catSelectValueWaste.cat + "Views"]: arr });
    } else {
      catSelectValueWaste.value.map((items, i) => {
        if (items.catalog_id === data.cat_id) {
          if (items.code === data.code) {
            catSelectValueWaste.value.splice(i, 1);
          }
        }
      });

      setValues({
        ...values,
        [catSelectValueWaste.cat]: catSelectValueWaste.value,
      });
    }

    setCatSelectWaste(false);
  };

  const changedeliveryLogistics = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.deliveryLogisticsData.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.deliveryLogisticsData.length > 0) {
          for (var i1 = 0; i1 < values.deliveryLogisticsData.length; i1++) {
            if (values.deliveryLogisticsData[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        deliveryLogisticsData: data,
        errorDeliveryLogistics: false,
      });
      setCatSelectValue({ value: data, cat: "deliveryLogisticsData" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.deliveryLogisticsDataViews);

      setValues({
        ...values,
        deliveryLogisticsData: data,
        deliveryLogisticsDataViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeLogisticsOutbound = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.logisticsOutboundData.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.logisticsOutboundData.length > 0) {
          for (var i1 = 0; i1 < values.logisticsOutboundData.length; i1++) {
            if (values.logisticsOutboundData[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        logisticsOutboundData: data,
        errorLogisticsOutbound: false,
      });
      setCatSelectValue({ value: data, cat: "logisticsOutboundData" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.logisticsOutboundDataViews);

      setValues({
        ...values,
        logisticsOutboundData: data,
        logisticsOutboundDataViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeOperations = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.operationsData.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.operationsData.length > 0) {
          for (var i1 = 0; i1 < values.operationsData.length; i1++) {
            if (values.operationsData[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        operationsData: data,
        errorOperations: false,
      });
      setCatSelectValue({ value: data, cat: "operationsData" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.operationsDataViews);

      setValues({
        ...values,
        operationsData: data,
        operationsDataViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeMarketing = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.marketingData.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.marketingData.length > 0) {
          for (var i1 = 0; i1 < values.marketingData.length; i1++) {
            if (values.marketingData[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        marketingData: data,
        errorMarketing: false,
      });
      setCatSelectValue({ value: data, cat: "marketingData" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.marketingDataViews);

      setValues({
        ...values,
        marketingData: data,
        marketingDataViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeServices = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.servicesData.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.servicesData.length > 0) {
          for (var i1 = 0; i1 < values.servicesData.length; i1++) {
            if (values.servicesData[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        servicesData: data,
        errorServices: false,
      });
      setCatSelectValue({ value: data, cat: "servicesData" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.servicesDataViews);

      setValues({
        ...values,
        servicesData: data,
        servicesDataViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeInfrastructure = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.infrastructureData.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.infrastructureData.length > 0) {
          for (var i1 = 0; i1 < values.infrastructureData.length; i1++) {
            if (values.infrastructureData[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        infrastructureData: data,
        errorInfrastructure: false,
      });
      setCatSelectValue({ value: data, cat: "infrastructureData" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.infrastructureDataViews);

      setValues({
        ...values,
        infrastructureData: data,
        infrastructureDataViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeHumanResources = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.humanResourcesData.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.humanResourcesData.length > 0) {
          for (var i1 = 0; i1 < values.humanResourcesData.length; i1++) {
            if (values.humanResourcesData[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        humanResourcesData: data,
        errorHumanResources: false,
      });
      setCatSelectValue({ value: data, cat: "humanResourcesData" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.humanResourcesDataViews);

      setValues({
        ...values,
        humanResourcesData: data,
        humanResourcesDataViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeDevelopmentTechnology = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.developmentTechnologyData.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.developmentTechnologyData.length > 0) {
          for (var i1 = 0; i1 < values.developmentTechnologyData.length; i1++) {
            if (values.developmentTechnologyData[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        developmentTechnologyData: data,
        errorDevelopmentTechnology: false,
      });
      setCatSelectValue({ value: data, cat: "developmentTechnologyData" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.developmentTechnologyDataViews);

      setValues({
        ...values,
        developmentTechnologyData: data,
        developmentTechnologyDataViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeBuy = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.buyData.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.buyData.length > 0) {
          for (var i1 = 0; i1 < values.buyData.length; i1++) {
            if (values.buyData[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        buyData: data,
        errorBuy: false,
      });
      setCatSelectValue({ value: data, cat: "buyData" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.buyDataViews);

      setValues({
        ...values,
        buyData: data,
        buyDataViews: data.length !== 0 ? output : data,
      });
    }
  };

  /* RECUROS RESIDUALES */

  const changeOrganicWaste = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.organicWasteData.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.organicWasteData.length > 0) {
          for (var i1 = 0; i1 < values.organicWasteData.length; i1++) {
            if (values.organicWasteData[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        organicWasteData: data,
        errorOrganicWaste: false,
      });
      setCatSelectValueWaste({ value: data, cat: "organicWasteData" });
      setCatSelectWaste(true);
      setdataCatWaste(datos);
    } else {
      output = deleteCatViewsWaste(data, values.organicWasteDataViews);

      setValues({
        ...values,
        organicWasteData: data,
        organicWasteDataViews: data.length !== 0 ? output : data,
      });
    }
  };

  const deleteCatViews = (data, cat) => {
    for (var i = 0; i < cat.length; i++) {
      var isAGoodUser = false;
      for (var y = 0; y < data.length; y++) {
        if (cat[i].detailName === data[y].detailName) {
          isAGoodUser = true;
          break;
        }
      }
      if (!isAGoodUser) {
        delectCat.push(cat[i]);
        cat.splice(i, 1);
      }
    }
    setdelectCat(delectCat);

    return cat;
  };

  const deleteCatViewsWaste = (data, cat) => {
    for (var i = 0; i < cat.length; i++) {
      var isAGoodUser = false;
      for (var y = 0; y < data.length; y++) {
        if (cat[i].detailName === data[y].detailName) {
          isAGoodUser = true;
          break;
        }
      }
      if (!isAGoodUser) {
        delectCat.push(cat[i]);
        cat.splice(i, 1);
      }
    }
    setdelectCat(delectCat);
    return cat;
  };

  const textCatSelect = (items) => {
    let output = [],
      numRows = items.transactionType.length;

    items.transactionType.map((items, i) => {
      output.push(items.detailName);

      if (i < numRows - 1) {
        output.push(", ");
      } else {
        output.push(".");
      }
      return output;
    });

    return (
      <Fragment>
        <p>
          <b>DESCRIPCIÓN:</b> {items.description}
          <br></br> <br></br>
          <b>VALOR ESTIMADO $:</b> {items.estimatedAmountName}
          <br></br> <br></br>
          <b>TIPO DE ACUERDO:</b> {output}
        </p>
      </Fragment>
    );
  };

  const includeHasArrayHave = (views) => {
    let output = [];

    views.map((items, i) => {
      if (items.view.length > 0) {
        for (var i1 = 0; i1 < items.view.length; i1++) {
          var isAGoodUser = false;
          for (var y = 0; y < items.values.length; y++) {
            if (items.values[y].detailName === items.view[i1].detailName) {
              isAGoodUser = true;
              break;
            }
          }
          if (!isAGoodUser) {
            output.push({
              have_id: items.view[i1].code,
              catalog_id: items.view[i1].cat_id,
              another: "0",
              description:
                items.view[i1].description === undefined
                  ? null
                  : items.view[i1].description,
              estimated_mount_id: items.view[i1].estimatedAmount,
              transaction_type: JSON.stringify(items.view[i1].transactionType),
              waste_state_id:
                items.view[i1].wasteState === undefined
                  ? null
                  : items.view[i1].wasteState,
              weight_kg_id:
                items.view[i1].weightKg === undefined
                  ? null
                  : items.view[i1].weightKg,
              transport_id:
                items.view[i1].transports === undefined
                  ? null
                  : items.view[i1].transports,
              waste_usage_id:
                items.view[i1].wasteUsage === undefined
                  ? null
                  : items.view[i1].wasteUsage,
              solution_type_id: null,
              stakeholder_id: values.stakeholder_id,
            });
          }
        }
      }
    });
    return output;
  };

  const textCatSelectWaste = (items) => {
    let output = [],
      numRows = items.transactionType.length;

    items.transactionType.map((items, i) => {
      output.push(items.detailName);

      if (i < numRows - 1) {
        output.push(", ");
      } else {
        output.push(".");
      }
      return output;
    });

    return (
      <Fragment>
        <p>
          <b>ESTADO:</b> {items.wasteStateName}
          <br></br> <br></br>
          <b>PESO EN KILOS:</b> {items.weightKgName}
          <br></br> <br></br>
          <b>VALOR ESTIMADO $:</b> {items.estimatedAmountName}
          <br></br> <br></br>
          <b>TIPO DE ACUERDO:</b> {output}
          <br></br> <br></br>
          <b>TRANSPORTE:</b> {items.transportsName}
          <br></br> <br></br>
          <b>USO DE RESIDUO:</b> {items.wasteUsageName}
        </p>
      </Fragment>
    );
  };

  const submitForm = (e) => {
    e.preventDefault();

    setOpenAlertsuccess(false);
    setoOpenBackdrop(true);

    let arrayHave = [
      {
        view: values.deliveryLogisticsDataViews,
        values: values.deliveryLogisticsSave,
      },
      {
        view: values.logisticsOutboundDataViews,
        values: values.logisticsOutboundSave,
      },
      { view: values.operationsDataViews, values: values.operationsSave },
      { view: values.marketingDataViews, values: values.marketingSave },
      { view: values.servicesDataViews, values: values.servicesSave },
      { view: values.buyDataViews, values: values.buySave },
      {
        view: values.humanResourcesDataViews,
        values: values.humanResourcesSave,
      },
      {
        view: values.infrastructureDataViews,
        values: values.infrastructureSave,
      },
      {
        view: values.developmentTechnologyDataViews,
        values: values.developmentTechnologySave,
      },
      {
        view: values.organicWasteDataViews,
        values: values.organicWasteSave,
      },
    ];

    let have = includeHasArrayHave(arrayHave);

    if (have.length > 0) {
      have.map((items, i) => {
        axios
          .post(`${urlServices}stakeholders-have`, items, {
            headers: {
              application: keyAplication,
              Authorization: "Bearer " + keyAuthorization,
            },
          })
          .then((response) => {
            if (response.status === 200) {
              setOpenAlertsuccess(true);
              setMensaje_success("Registro guardado con exito!");
              setoOpenBackdrop(false);
            }
          })
          .catch((e) => {});
      });
    }

    if (delectCat.length > 0) {
      delectCat.map((items, i) => {
        axios
          .delete(`${urlServices}stakeholders-have/${items.id}`, {
            headers: {
              application: keyAplication,
              Authorization: "Bearer " + keyAuthorization,
            },
          })
          .then((response) => {
            if (response.status === 200) {
              setOpenAlertsuccess(true);
              setMensaje_success("Registro guardado con exito!");
              setoOpenBackdrop(false);
            }
          })
          .catch((e) => {});
      });
    }
  };

  const icon = <CheckBoxOutlineBlank fontSize="small" />;
  const checkedIcon = <CheckBox fontSize="small" />;

  return (
    <Fragment>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card chart>
            <CardBody>
              <Grid container spacing={2} className={classes.containerStyle}>
                <Grid item xs={12} sm={12} style={{ marginTop: 10 }}>
                  <div className={classes.titleCardSub2}>
                    RECURSOS QUE YO TENGO
                  </div>
                  <Divider variant="fullWidth" style={{ marginBottom: "4%" }} />
                </Grid>
                <Grid item xs={12} sm={12} style={{ marginTop: 10 }}>
                  <div className={classes.titleCardSub2}>
                    <Reorder className={classes.iconSubTitle} />
                    ACTIVIDADES PRIMARIAS
                  </div>
                </Grid>
                <Grid item xs={12} sm={12}>
                  {errorServer ? (
                    <Alert severity="error">
                      Error en la consulta al servidor
                    </Alert>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {loader ? (
                    <Fragment>
                      <FormLabel component="legend">
                        Logística de entrega
                      </FormLabel>
                      <center>
                        <Skeleton width={300} height={40} />
                      </center>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <Autocomplete
                        multiple
                        size="small"
                        id="deliveryLogistics"
                        options={values.deliveryLogistics}
                        value={values.deliveryLogisticsData}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.detailName}
                        onChange={changedeliveryLogistics}
                        getOptionSelected={(option, value) => {
                          return option.detailName === value.detailName;
                        }}
                        renderOption={(option, { selected }) => (
                          <Fragment>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                              color="primary"
                            />
                            {option.detailName}
                          </Fragment>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={values.errorDeliveryLogistics}
                            name="deliveryLogistics"
                            //  required
                            label="Logística de entrega"
                            margin="dense"
                          />
                        )}
                      />
                      <List>
                        {values.deliveryLogisticsDataViews.map((items, i) => {
                          return (
                            <ListItem
                              key={items}
                              role={undefined}
                              dense
                              className={classes.listCatalogSelect}
                            >
                              <ListItemIcon>
                                <HtmlTooltip title={textCatSelect(items)}>
                                  <Pageview style={{ cursor: "pointer" }} />
                                </HtmlTooltip>
                              </ListItemIcon>
                              <ListItemText
                                id={items}
                                primary={`${items.detailName}`}
                              />
                            </ListItem>
                          );
                        })}
                      </List>
                    </Fragment>
                  )}
                </Grid>

                <Grid item xs={12} sm={6}>
                  {loader ? (
                    <Fragment>
                      <FormLabel component="legend">
                      Logística de salida
                      </FormLabel>
                      <center>
                        <Skeleton width={300} height={40} />
                      </center>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <Autocomplete
                        multiple
                        size="small"
                        id="logisticsOutbound"
                        options={values.logisticsOutbound}
                        value={values.logisticsOutboundData}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.detailName}
                        onChange={changeLogisticsOutbound}
                        getOptionSelected={(option, value) => {
                          return option.detailName === value.detailName;
                        }}
                        renderOption={(option, { selected }) => (
                          <Fragment>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                              color="primary"
                            />
                            {option.detailName}
                          </Fragment>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={values.errorLogisticsOutbound}
                            name="logisticsOutbound"
                            //  required
                            label="Logística de salida"
                            margin="dense"
                          />
                        )}
                      />
                      <List>
                        {values.logisticsOutboundDataViews.map((items, i) => {
                          return (
                            <ListItem
                              key={items}
                              role={undefined}
                              dense
                              className={classes.listCatalogSelect}
                            >
                              <ListItemIcon>
                                <HtmlTooltip title={textCatSelect(items)}>
                                  <Pageview style={{ cursor: "pointer" }} />
                                </HtmlTooltip>
                              </ListItemIcon>

                              <ListItemText
                                id={items}
                                primary={`${items.detailName}`}
                              />
                            </ListItem>
                          );
                        })}
                      </List>
                    </Fragment>
                  )}
                </Grid>

                <Grid item xs={12} sm={6}>
                  {loader ? (
                    <Fragment>
                      <FormLabel component="legend">Operaciones</FormLabel>
                      <center>
                        <Skeleton width={300} height={40} />
                      </center>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <Autocomplete
                        multiple
                        size="small"
                        id="operations"
                        options={values.operations}
                        value={values.operationsData}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.detailName}
                        onChange={changeOperations}
                        getOptionSelected={(option, value) => {
                          return option.detailName === value.detailName;
                        }}
                        renderOption={(option, { selected }) => (
                          <Fragment>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                              color="primary"
                            />
                            {option.detailName}
                          </Fragment>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={values.errorOperations}
                            name="operations"
                            //  required
                            label="Operaciones"
                            margin="dense"
                          />
                        )}
                      />
                      <List>
                        {values.operationsDataViews.map((items, i) => {
                          return (
                            <ListItem
                              key={items}
                              role={undefined}
                              dense
                              className={classes.listCatalogSelect}
                            >
                              <ListItemIcon>
                                <HtmlTooltip title={textCatSelect(items)}>
                                  <Pageview style={{ cursor: "pointer" }} />
                                </HtmlTooltip>
                              </ListItemIcon>

                              <ListItemText
                                id={items}
                                primary={`${items.detailName}`}
                              />
                            </ListItem>
                          );
                        })}
                      </List>
                    </Fragment>
                  )}
                </Grid>

                <Grid item xs={12} sm={6}>
                  {loader ? (
                    <Fragment>
                      <center>
                        <FormLabel component="legend">Marketing</FormLabel>
                        <Skeleton width={300} height={40} />
                      </center>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <Autocomplete
                        multiple
                        size="small"
                        id="marketing"
                        options={values.marketing}
                        value={values.marketingData}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.detailName}
                        onChange={changeMarketing}
                        getOptionSelected={(option, value) => {
                          return option.detailName === value.detailName;
                        }}
                        renderOption={(option, { selected }) => (
                          <Fragment>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                              color="primary"
                            />
                            {option.detailName}
                          </Fragment>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={values.errorMarketings}
                            name="marketing"
                            //  required
                            label="Marketing y ventas"
                            margin="dense"
                          />
                        )}
                      />
                      <List>
                        {values.marketingDataViews.map((items, i) => {
                          return (
                            <ListItem
                              key={items}
                              role={undefined}
                              dense
                              className={classes.listCatalogSelect}
                            >
                              <ListItemIcon>
                                <HtmlTooltip title={textCatSelect(items)}>
                                  <Pageview style={{ cursor: "pointer" }} />
                                </HtmlTooltip>
                              </ListItemIcon>

                              <ListItemText
                                id={items}
                                primary={`${items.detailName}`}
                              />
                            </ListItem>
                          );
                        })}
                      </List>
                    </Fragment>
                  )}
                </Grid>

                <Grid item xs={12} sm={6}>
                  {loader ? (
                    <Fragment>
                      <FormLabel component="legend">Servicios</FormLabel>
                      <center>
                        <Skeleton width={300} height={40} />
                      </center>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <Autocomplete
                        multiple
                        size="small"
                        id="services"
                        options={values.services}
                        value={values.servicesData}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.detailName}
                        onChange={changeServices}
                        getOptionSelected={(option, value) => {
                          return option.detailName === value.detailName;
                        }}
                        renderOption={(option, { selected }) => (
                          <Fragment>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                              color="primary"
                            />
                            {option.detailName}
                          </Fragment>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={values.errorServices}
                            name="services"
                            //  required
                            label="Servicios"
                            margin="dense"
                          />
                        )}
                      />
                      <List>
                        {values.servicesDataViews.map((items, i) => {
                          return (
                            <ListItem
                              key={items}
                              role={undefined}
                              dense
                              className={classes.listCatalogSelect}
                            >
                              <ListItemIcon>
                                <HtmlTooltip title={textCatSelect(items)}>
                                  <Pageview style={{ cursor: "pointer" }} />
                                </HtmlTooltip>
                              </ListItemIcon>

                              <ListItemText
                                id={items}
                                primary={`${items.detailName}`}
                              />
                            </ListItem>
                          );
                        })}
                      </List>
                    </Fragment>
                  )}
                </Grid>

                {/* SCTION 2*/}

                <Grid item xs={12} sm={12} style={{ marginTop: 10 }}>
                  <div className={classes.titleCardSub2}>
                    <Repeat className={classes.iconSubTitle} />
                    ACTIVIDADES DE APOYO Y SOPORTE
                  </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                  {loader ? (
                    <Fragment>
                      <FormLabel component="legend">Infraestructura</FormLabel>
                      <center>
                        <Skeleton width={300} height={40} />
                      </center>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <Autocomplete
                        multiple
                        size="small"
                        id="infrastructure"
                        options={values.infrastructure}
                        value={values.infrastructureData}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.detailName}
                        onChange={changeInfrastructure}
                        getOptionSelected={(option, value) => {
                          return option.detailName === value.detailName;
                        }}
                        renderOption={(option, { selected }) => (
                          <Fragment>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                              color="primary"
                            />
                            {option.detailName}
                          </Fragment>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={values.errorInfrastructure}
                            name="infrastructure"
                            //  required
                            label="Infraestructura"
                            margin="dense"
                          />
                        )}
                      />
                      <List>
                        {values.infrastructureDataViews.map((items, i) => {
                          return (
                            <ListItem
                              key={items}
                              role={undefined}
                              dense
                              className={classes.listCatalogSelect}
                            >
                              <ListItemIcon>
                                <HtmlTooltip title={textCatSelect(items)}>
                                  <Pageview style={{ cursor: "pointer" }} />
                                </HtmlTooltip>
                              </ListItemIcon>

                              <ListItemText
                                id={items}
                                primary={`${items.detailName}`}
                              />
                            </ListItem>
                          );
                        })}
                      </List>
                    </Fragment>
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {loader ? (
                    <Fragment>
                      <FormLabel component="legend">Recursos humanos</FormLabel>
                      <center>
                        <Skeleton width={300} height={40} />
                      </center>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <Autocomplete
                        multiple
                        size="small"
                        id="humanResources"
                        options={values.humanResources}
                        value={values.humanResourcesData}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.detailName}
                        onChange={changeHumanResources}
                        getOptionSelected={(option, value) => {
                          return option.detailName === value.detailName;
                        }}
                        renderOption={(option, { selected }) => (
                          <Fragment>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                              color="primary"
                            />
                            {option.detailName}
                          </Fragment>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={values.errorHumanResources}
                            name="humanResources"
                            //  required
                            label="Recursos humanos"
                            margin="dense"
                          />
                        )}
                      />
                      <List>
                        {values.humanResourcesDataViews.map((items, i) => {
                          return (
                            <ListItem
                              key={items}
                              role={undefined}
                              dense
                              className={classes.listCatalogSelect}
                            >
                              <ListItemIcon>
                                <HtmlTooltip title={textCatSelect(items)}>
                                  <Pageview style={{ cursor: "pointer" }} />
                                </HtmlTooltip>
                              </ListItemIcon>

                              <ListItemText
                                id={items}
                                primary={`${items.detailName}`}
                              />
                            </ListItem>
                          );
                        })}
                      </List>
                    </Fragment>
                  )}
                </Grid>

                <Grid item xs={12} sm={6}>
                  {loader ? (
                    <Fragment>
                      <FormLabel component="legend">
                        Desarrollo de tecnología
                      </FormLabel>
                      <center>
                        <Skeleton width={300} height={40} />
                      </center>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <Autocomplete
                        multiple
                        size="small"
                        id="developmentTechnology"
                        options={values.developmentTechnology}
                        value={values.developmentTechnologyData}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.detailName}
                        onChange={changeDevelopmentTechnology}
                        getOptionSelected={(option, value) => {
                          return option.detailName === value.detailName;
                        }}
                        renderOption={(option, { selected }) => (
                          <Fragment>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                              color="primary"
                            />
                            {option.detailName}
                          </Fragment>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={values.errorDevelopmentTechnology}
                            name="developmentTechnology"
                            //  required
                            label="Desarrollo de tecnología"
                            margin="dense"
                          />
                        )}
                      />
                      <List>
                        {values.developmentTechnologyDataViews.map(
                          (items, i) => {
                            return (
                              <ListItem
                                key={items}
                                role={undefined}
                                dense
                                className={classes.listCatalogSelect}
                              >
                                <ListItemIcon>
                                  <HtmlTooltip title={textCatSelect(items)}>
                                    <Pageview style={{ cursor: "pointer" }} />
                                  </HtmlTooltip>
                                </ListItemIcon>

                                <ListItemText
                                  id={items}
                                  primary={`${items.detailName}`}
                                />
                              </ListItem>
                            );
                          }
                        )}
                      </List>
                    </Fragment>
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {loader ? (
                    <Fragment>
                      <FormLabel component="legend">Compras</FormLabel>
                      <center>
                        <Skeleton width={300} height={40} />
                      </center>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <Autocomplete
                        multiple
                        size="small"
                        id="buy"
                        options={values.buy}
                        value={values.buyData}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.detailName}
                        onChange={changeBuy}
                        getOptionSelected={(option, value) => {
                          return option.detailName === value.detailName;
                        }}
                        renderOption={(option, { selected }) => (
                          <Fragment>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                              color="primary"
                            />
                            {option.detailName}
                          </Fragment>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={values.errorBuy}
                            name="buy"
                            //  required
                            label="Compras"
                            margin="dense"
                          />
                        )}
                      />
                      <List>
                        {values.buyDataViews.map((items, i) => {
                          return (
                            <ListItem
                              key={items}
                              role={undefined}
                              dense
                              className={classes.listCatalogSelect}
                            >
                              <ListItemIcon>
                                <HtmlTooltip title={textCatSelect(items)}>
                                  <Pageview style={{ cursor: "pointer" }} />
                                </HtmlTooltip>
                              </ListItemIcon>

                              <ListItemText
                                id={items}
                                primary={`${items.detailName}`}
                              />
                            </ListItem>
                          );
                        })}
                      </List>
                    </Fragment>
                  )}
                </Grid>
                {/* SCTION 3*/}

                <Grid item xs={12} sm={12} style={{ marginTop: 10 }}>
                  <div className={classes.titleCardSub2}>
                    <Opacity className={classes.iconSubTitle} />
                    RECURSOS RESIDUALES
                  </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                  {loader ? (
                    <Fragment>
                      <FormLabel component="legend">
                        Desechos orgánicos
                      </FormLabel>
                      <center>
                        <Skeleton width={300} height={40} />
                      </center>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <Autocomplete
                        multiple
                        size="small"
                        id="organicWaste"
                        options={values.organicWaste}
                        value={values.organicWasteData}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.detailName}
                        onChange={changeOrganicWaste}
                        getOptionSelected={(option, value) => {
                          return option.detailName === value.detailName;
                        }}
                        renderOption={(option, { selected }) => (
                          <Fragment>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                              color="primary"
                            />
                            {option.detailName}
                          </Fragment>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={values.errorOrganicWaste}
                            name="organicWaste"
                            //  required
                            label="Desechos orgánicos"
                            margin="dense"
                          />
                        )}
                      />
                      <List>
                        {values.organicWasteDataViews.map((items, i) => {
                          return (
                            <ListItem
                              key={items}
                              role={undefined}
                              dense
                              className={classes.listCatalogSelect}
                            >
                              <ListItemIcon>
                                <HtmlTooltip title={textCatSelectWaste(items)}>
                                  <Pageview style={{ cursor: "pointer" }} />
                                </HtmlTooltip>
                              </ListItemIcon>

                              <ListItemText
                                id={items}
                                primary={`${items.detailName}`}
                              />
                            </ListItem>
                          );
                        })}
                      </List>
                    </Fragment>
                  )}
                </Grid>
                <Grid item xs={12} sm={12} style={{ margin: "20px 0" }}>
                  <center>
                    {openAlertsuccess ? (
                      <Alert severity="success">{mensaje_success}</Alert>
                    ) : (
                      ""
                    )}
                    <br></br>
                    <Button
                      onClick={submitForm}
                      className={classes.buttonSubmit}
                    >
                      Guardar
                    </Button>
                  </center>
                </Grid>
              </Grid>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      {catSelect ? (
        <ResourcesData
          callback={callbackResourcesData}
          open={catSelect}
          data={dataCat}
        />
      ) : (
        ""
      )}
      {catSelectWaste ? (
        <WasteResourcesData
          callback={callbackWasteResourcesData}
          open={catSelectWaste}
          data={dataCatWaste}
        />
      ) : (
        ""
      )}
      <Backdrop
        style={{ zIndex: "9999", color: "#FFFFFF" }}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Fragment>
  );
}
